import { useQuery } from "@tanstack/react-query";
import { getTargetareContacteStats } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareContacteStats() {
  return useQuery({
    queryKey: queryKeys.targetare.contacteStats(),
    queryFn: getTargetareContacteStats,
    select: (response) => response.data,
    staleTime: 1000 * 30,
    retry: 1,
    refetchInterval: (query) => {
      const coada = query.state.data?.data.descoperire;
      const active = (coada?.de_procesat ?? 0) + (coada?.in_curs ?? 0);
      return active > 0 ? 15000 : false;
    },
    refetchIntervalInBackground: true,
  });
}
